import React, { useEffect, useState } from "react";

const FillBlank = ({ setCurrentSlideData, contentId, data }) => {
  const [state, setState] = useState({
    question: "",
    options: ["", "", "", ""],
    correctAnswer: null,
  });

  useEffect(() => {
    setCurrentSlideData((currentSlideData) => {
      let newCurrentSlideData = {
        ...currentSlideData,
        content: currentSlideData.content.map((contentObj) => {
          if (contentObj.id === contentId) {
            return { ...contentObj, data: state };
          } else {
            return contentObj;
          }
        }),
      };
      return newCurrentSlideData;
    });
  }, [state]);

  useEffect(() => {
    if (data) {
      setState(data);
    }
  }, []);

  const handleQuestionChange = (e) => {
    setState((prev) => ({ ...prev, question: e.target.value }));
  };

  const handleOptionChange = (index, value) => {
    setState((prev) => {
      const updatedOptions = [...prev.options];
      updatedOptions[index] = value;
      return { ...prev, options: updatedOptions };
    });
  };

  const handleCorrectAnswerChange = (index) => {
    setState((prev) => ({ ...prev, correctAnswer: index }));
  };

  return (
    <div className="font-sans">
      <h1 className="text-2xl font-bold mb-4">Fill in the Blank</h1>

      {/* Question Input */}
      <textarea
        value={state.question}
        placeholder="Enter question (e.g., I like ...... apple)"
        onChange={handleQuestionChange}
        rows="2"
        className="w-full p-2 border border-gray-300 rounded-md mb-4"
      />

      {/* Options Grid (2 per row) */}
      <h3 className="text-lg font-medium mb-2">Options:</h3>
      <div className="grid grid-cols-2 gap-4">
        {state.options.map((option, index) => (
          <div key={index} className="relative">
            <input
              type="text"
              value={option}
              placeholder={`Option ${index + 1}`}
              onChange={(e) => handleOptionChange(index, e.target.value)}
              className="w-full p-2 border border-gray-300 rounded-md pl-8" // Left padding for radio button
            />
            <input
              type="radio"
              name={contentId}
              checked={state.correctAnswer === index}
              onChange={() => handleCorrectAnswerChange(index)}
              className="absolute left-2 top-1/2 transform -translate-y-1/2"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default FillBlank;
